export function normalizeToF32(raw: any): Float32Array | null {
  if (raw instanceof Float32Array) return raw;
  if (raw instanceof Int16Array) {
    const out = new Float32Array(raw.length);
    for (let i = 0; i < raw.length; i++) out[i] = raw[i] / 32768;
    return out;
  }
  if (raw instanceof Uint8Array) {
    if ((raw.byteLength & 1) !== 0) return null;
    const i16 = new Int16Array(raw.buffer, raw.byteOffset, raw.byteLength >> 1);
    return normalizeToF32(i16);
  }

  // 2) wrapped formats
  if (raw && raw.pcm) return normalizeToF32(raw.pcm);
  if (raw && raw.data) return normalizeToF32(raw.data);

  // planar: { channelData: Float32Array[] }
  if (raw && Array.isArray(raw.channelData) && raw.channelData.length > 0) {
    const chs: Float32Array[] = raw.channelData;
    const len = chs[0].length;
    const out = new Float32Array(len);

    if (chs.length === 1) {
      out.set(chs[0]);
    } else {
      for (let i = 0; i < len; i++) {
        let acc = 0;
        for (let c = 0; c < chs.length; c++) acc += chs[c][i];
        out[i] = acc / chs.length;
      }
    }
    return out;
  }

  // raw buffers
  if (raw && raw.buffer instanceof ArrayBuffer) {
    return normalizeToF32(
      new Uint8Array(raw.buffer, raw.byteOffset ?? 0, raw.byteLength ?? raw.buffer.byteLength),
    );
  }
  if (raw && raw.arrayBuffer instanceof ArrayBuffer) {
    return normalizeToF32(new Uint8Array(raw.arrayBuffer));
  }

  if (Array.isArray(raw) && raw.length && typeof raw[0] === 'number') {
    const out = new Float32Array(raw.length);
    for (let i = 0; i < raw.length; i++) {
      const v = raw[i];
      out[i] = Math.max(-1, Math.min(1, v));
    }
    return out;
  }

  return null;
}
